module.exports = __webpack_public_path__ + "img/exmpl-ui_space-navigator.dd8ad667.png";